import { render, staticRenderFns } from "./crudTree.vue?vue&type=template&id=40ea4c02"
import script from "./crudTree.vue?vue&type=script&lang=js"
export * from "./crudTree.vue?vue&type=script&lang=js"
import style0 from "./crudTree.vue?vue&type=style&index=0&id=40ea4c02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports